import React, { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate, useParams, Link } from "react-router-dom"
import { FaAngleLeft, FaQuestion } from 'react-icons/fa'
import { GiAnvilImpact, GiArchiveRegister, GiHut, GiHutsVillage, GiStoneAxe } from 'react-icons/gi'
import Alert from 'react-bootstrap/Alert'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import { apiURL, filesURL } from 'config/globals'
import Topbar from 'components/Topbar'
import Footer from 'components/Footer'
import { checkAuth } from 'utils/Auth'

const MuseumArchive = () => {
    const [currentUser, setCurrentUser] = useState()
    const [museum, setMuseum] = useState({})
    const [loadError, setLoadError] = useState('')
    const navigate = useNavigate()
    const { entityId } = useParams()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            await getMuseum()
        }
        start()
    }, [])

    const getMuseum = async () => {
        try {
            const response = await axios.get(`${apiURL}/get-museum/${entityId}`)

            if (!response.data.success) {
                setLoadError("Cannot load museum data: " + (response.data.error || response.data))
                return
            }

            setMuseum(response.data.item)
        } catch (error) {
            setLoadError(JSON.stringify(error))
        }
    }

    const jumpToBuildings = () => {
        navigate(`/museum/${entityId}/archive/buildings`)
    }

    const jumpToCrafts = () => {
        navigate(`/museum/${entityId}/archive/crafts`)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <main className="full-width">
                {museum.id &&
                    <>
                        <div>
                            <Link to={`/museum/${museum.id}/dashboard`} className="no-decoration"><FaAngleLeft /> Back to Home</Link>
                        </div>
                        <header className="mt-2">
                            <div className="float-start">
                                <h1>Museum Archive</h1>
                            </div>
                        </header>
                        <Row>
                            <Col sm="6" md="4" lg="3" key="">
                                <Card className="navItem mb-4" onClick={jumpToBuildings}>
                                    <Card.Body>
                                        <div className="navIcon"><GiHut /></div>
                                        <Card.Title>Buildings<br/>&nbsp;</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm="6" md="4" lg="3" key="">
                                <Card className="navItem disabled mb-4">
                                    <Card.Body>
                                        <div className="navIcon"><GiHutsVillage /></div>
                                        <Card.Title>Building<br/>Sets</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm="6" md="4" lg="3" key="">
                                <Card className="navItem disabled mb-4">
                                    <Card.Body>
                                        <div className="navIcon"><GiStoneAxe /></div>
                                        <Card.Title>Other<br/>Objects</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="6" md="4" lg="3" key="">
                                <Card className="navItem mb-4" onClick={jumpToCrafts}>
                                    <Card.Body>
                                        <div className="navIcon"><GiAnvilImpact /></div>
                                        <Card.Title>Craft<br/>Archive</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm="6" md="4" lg="3" key="">
                                <Card className="navItem disabled mb-4">
                                    <Card.Body>
                                        <div className="navIcon"><GiArchiveRegister /></div>
                                        <Card.Title>Admin<br/>Documents</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm="6" md="4" lg="3" key="">
                                <Card className="navItem disabled mb-4">
                                    <Card.Body>
                                        <div className="navIcon"><FaQuestion /></div>
                                        <Card.Title>RETOLD<br/>Tutorials</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </>
                }
                {loadError &&
                    <>
                        <Alert key='loadError' variant='danger'>
                            {loadError}
                        </Alert>
                    </>
                }
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default MuseumArchive